import { useHistory } from "react-router-dom";
import { CUSTOM_IMPORT, IMPORT, WEIGHT_IMPORT } from "constants/Routes";
import { useGetSupportedSystems } from "hooks";
import { Flex, Icon, Paper, Spacer, Text, Title } from "components";
import { ImportSystem } from "./ImportSystem";
import styles from "./ImportType.module.scss";
import { WizardOptions } from "import/components/WizardOptions";

export const ImportTypes = () => {
  const history = useHistory();

  const handleClickCustom = () => history.push(`${IMPORT}${CUSTOM_IMPORT}`);
  const handleClickSystems = () => history.push(`${IMPORT}${WEIGHT_IMPORT}`);

  const { data: integrationSystems } = useGetSupportedSystems();

  return (
    <Flex item itemGutter>
      <Paper className={styles.import_types}>
        <Spacer baselineHeight={5} />

        <Flex container containerJustifyContent="center">
          <Title tertiary>How do you want to upload</Title>

          <Spacer baselineHeight={1} />

          <Text smaller>We support custom upload or supported systems</Text>
        </Flex>

        <Spacer baselineHeight={4} />

        <WizardOptions>
          <WizardOptions.Option name="Custom import" onClick={handleClickCustom}>
            <Icon circled colour="grey100" name="fileCsv" size="large" />
          </WizardOptions.Option>

          {!!integrationSystems.length && (
            <WizardOptions.Option name="Supported systems" onClick={handleClickSystems}>
              <Flex container>
                {integrationSystems.map((integrationSystem) => (
                  <Flex item itemGutter key={integrationSystem.id}>
                    {integrationSystem.logo ? (
                      <ImportSystem>
                        <img alt={`${integrationSystem.name} logo`} src={integrationSystem.logo} />
                      </ImportSystem>
                    ) : (
                      <ImportSystem name={integrationSystem.name} />
                    )}
                  </Flex>
                ))}
              </Flex>
            </WizardOptions.Option>
          )}
        </WizardOptions>

        <Spacer baselineHeight={5} />
      </Paper>
    </Flex>
  );
};
